import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const FillWarning = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.8731 19.5306L13.3104 3.79161C12.7402 2.73613 11.2698 2.73613 10.6996 3.79161L2.12688 19.5306C1.76677 20.1825 2.21691 21 2.92714 21H21.0729C21.7831 21 22.2332 20.1825 21.8731 19.5306ZM11.2298 8.69646C11.2298 8.22046 11.5999 7.8376 12.06 7.8376C12.5202 7.8376 12.8903 8.22046 12.8903 8.69646V13.8704C12.8903 14.3464 12.5202 14.7292 12.06 14.7292C11.5999 14.7292 11.2298 14.3464 11.2298 13.8704V8.69646ZM12.14 18.6097H12.11C11.4298 18.6097 10.8696 18.0509 10.8396 17.3472C10.8196 16.6436 11.3498 16.0538 12.03 16.0331H12.06C12.7402 16.0331 13.3004 16.5918 13.3304 17.2955C13.3504 17.9991 12.8203 18.589 12.14 18.6097Z"
      fill="#565B6D"
    />
  </svg>
)

export default withDefaultStyles(FillWarning)
